import { withStyles } from '@material-ui/core'

import { TooltipBase } from './Tooltip'

import { styles } from './styles'

export const Tooltip = withStyles(styles)(TooltipBase)



// WEBPACK FOOTER //
// ./src/components/Tooltip/index.js